import React, { useState, useEffect } from 'react';
import { apiClient } from '../../utils/apiClient';

import Heart from './../icons/Heart';
import HeartFull from './../icons/HeartFull';

interface AddFavoriteProps {
  dossierId: string;
}

const AddFavorite: React.FC<AddFavoriteProps> = ({ dossierId }) => {
  const [isFavorite, setIsFavorite] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkIfFavorite = async () => {
      try {
        const response = await apiClient('/favorites/');
        if (response.ok) {
          const favorites = await response.json();
          const isFavorited = favorites.some((fav: any) => fav.dossier._id === dossierId);
          setIsFavorite(isFavorited);
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du statut de favori:', error);
      } finally {
        setLoading(false);
      }
    };
    checkIfFavorite();
  }, [dossierId]);

  const toggleFavorite = async () => {
    try {
      let response;
      if (isFavorite) {
        response = await apiClient('/favorites/', {
          method: 'DELETE',
          body: JSON.stringify({ dossierId }),
        });
      } else {
        response = await apiClient('/favorites/', {
          method: 'POST',
          body: JSON.stringify({ dossierId }),
        });
      }
      if (response.ok) {
        setIsFavorite((prev) => !prev);
      } else {
        console.error('Erreur lors du changement du statut de favori');
      }
    } catch (error) {
      console.error('Erreur lors du changement du statut de favori:', error);
    }
  };

  if (loading) {
    return (
      <div className="w-7 h-7 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
    );
  }

  return (
    <button
      onClick={toggleFavorite}
      aria-label={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
      className="p-1 rounded-full text-mcdm-third-400 dark:text-mcdm-primary-200 hover:text-mcdm-third-500 dark:hover:text-mcdm-primary-100 hover:bg-mcdm-primary-200 dark:hover:bg-mcdm-third-300 transition-colors focus:outline-none"
    >
      {isFavorite ? (
        <HeartFull
          width="24px"
          height="24px"
          style={{ transition: 'all 0.2s ease-in-out' }}
        />
      ) : (
        <Heart
          width="24px"
          height="24px"
          style={{ transition: 'all 0.2s ease-in-out' }}
        />
      )}
    </button>
  );
};

export default AddFavorite;